import React from 'react'
import { InlineSearch } from '@viki-ui/inline-search'
import { Associations, GenerateLink, Highlighter } from 'scripts/helpers/AppHelper'
import { soompi } from 'scripts/api/SoompiApi'
import ClientErrors from 'scripts/lib/ClientErrors'
import locale, { getLang } from 'shared/i18n/react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'

class NavInlineSearch extends React.Component {
  getSearchResults = (query) => {
    const params = { query: query }
    const { noOfPosts, noOfTags } = this.props

    this.promises = [
      soompi.getSearch(params),
      soompi.getFanClubSearch(params),
      soompi.getTagSearch(params)
    ]

    return Promise
      .all(this.promises.map(p => p.promise.catch(e => e)))
      .then(results => results.map(item => item.results))
      .then(results => {
        let [ posts = [], fanClubs = [], tags = [] ] = results

        const isEmpty = (posts.length + tags.length + fanClubs.length) === 0
        if (isEmpty) {
          const status = {
            classes: 'status-message',
            text: locale.formatString(locale.search.noResult, `"${query}"`)
          }

          return { items: { posts, tags, fanClubs }, status: status }
        }

        // fanClubs are always prioritized over tags
        // If there are 4 fanClubs and the noOfTags to be shown is 4,
        // only fanClubs will be displayed
        posts = posts.slice(0, noOfPosts)
        fanClubs = fanClubs.slice(0, noOfTags)
        tags = tags.slice(0, noOfTags - fanClubs.length)

        return { items: { posts, fanClubs, tags }, status: undefined }
      })
      .catch((e) => {
        ClientErrors({
          message: 'Search fetch results failed.',
          error: e
        })

        const status = {
          classes: 'status-message',
          text: 'Search fetch results failed.'
        }

        const empty = { posts: [], tags: [], status: [] }
        return { items: empty, status: status }
      })
  }

  navigateToSearch = (query) => {
    const urlEncodedValue = encodeURIComponent(query)
    const lang = getLang()
    const url = `/${lang}/search?query=${urlEncodedValue}`

    let { history } = this.props
    history.push(url)
  }

  renderPostContainer = (query, results, onCloseCallback, customClasses) => {
    const { posts } = results

    const hasPosts = posts && posts.length
    if (!hasPosts) return null

    const header = locale.formatString(locale.search.postsLabel, query)
    const styledText = (str) => Highlighter(query, str)

    return (
      <div className={customClasses}>
        <div className='container-header'>
          {header}
        </div>
        <ul>
          {
            posts.map((post, idx) =>
              <li className='item--post'
                key={idx}
                tabIndex={0}>
                <GenerateLink
                  { ...post }
                  element={styledText(post.title)}
                  customOnClick={onCloseCallback}
                />
              </li>
            )
          }
        </ul>
      </div>
    )
  }

  renderTagAndFanclubContainer = (query, results, onCloseCallback, customClasses) => {
    const { tags, fanClubs } = results

    const hasTagsOrFanclubs = (tags && tags.length) || (fanClubs && fanClubs.length)
    if (!hasTagsOrFanclubs) return null

    const header = locale.formatString(locale.search.tagsLabel, query)

    return (
      <div className={customClasses}>
        <div className='container-header'>{header}</div>
        <div>
          <Associations
            type='fanclub'
            data={fanClubs}
            assocClass='badges tags tag-item item--tag'
            customOnClick={onCloseCallback} />
          <Associations
            type='tag'
            data={tags}
            assocClass='badges tags fanclub-item item--tag'
            customOnClick={onCloseCallback} />
        </div>
      </div>
    )
  }

  renderSearchResults = (query, results, onCloseCallback) => {
    const postContainerClasses = 'container--posts'
    const tagsContainerClasses = 'container--tags'

    return (
      <React.Fragment>
        { this.renderTagAndFanclubContainer(query, results, onCloseCallback, tagsContainerClasses) }
        { this.renderPostContainer(query, results, onCloseCallback, postContainerClasses) }
      </React.Fragment>
    )
  }

  render() {
    return (
      <InlineSearch
        classes='soompi-inline-search'
        iconSearchClass='icon-search'
        iconCancelClass='icon-cancel'
        searchFn={this.getSearchResults}
        renderFn={this.renderSearchResults}
        navigateToSearch={this.navigateToSearch}
        placeholder={locale.search.textbox}
        statusMsg= {{
          LOADING: { text: locale.search.loading },
          ERROR: { text: locale.search.error }
        }}
      />
    )
  }
}

NavInlineSearch.propTypes = {
  history: PropTypes.object.isRequired,
  noOfPosts: PropTypes.number.isRequired,
  noOfTags: PropTypes.number.isRequired
}

NavInlineSearch.defaultProps = {
  noOfPosts: 6,
  noOfTags: 4
}

export default withRouter(NavInlineSearch)



// WEBPACK FOOTER //
// ./assets/js/components/search/NavInlineSearch.jsx